import { Page } from '../../../../application/page';
import { PageVariation } from '../../../../application/page-variation';
import { Command } from '../command';

export class RemovePageVariationCommand implements Command {
  constructor(public data: Data) {}

  apply(): void {
    this.data.parentPage.removeVariation(this.data.removedVariation);
  }

  unapply(): void {
    this.data.parentPage.addPageVariation(this.data.removedVariation, this.data.position);
  }
}

interface Data {
  removedVariation: PageVariation;
  parentPage: Page;
  position: number;
}
